export const ACTION_TRACKER_ACCESS = "action_tracker_access";
export const ACTION_TRACKER_CREATE = "action_tracker_create";
export const ACTION_TRACKER_VIEW = "action_tracker_view";
export const ACTION_TRACKER_EDIT = "action_tracker_edit";
export const ACTION_TRACKER_DELETE = "action_tracker_delete";
export const ACTION_TRACKER_COMMENT = "action_tracker_comment";

export const IMPLEMENTATION_SCHEDULE_ACCESS = "implementation_schedule_access";
export const IMPLEMENTATION_SCHEDULE_CREATE = "implementation_schedule_create";
export const IMPLEMENTATION_SCHEDULE_VIEW = "implementation_schedule_view";
export const IMPLEMENTATION_SCHEDULE_EDIT = "implementation_schedule_edit";
export const IMPLEMENTATION_SCHEDULE_DELETE = "implementation_schedule_delete";
export const IMPLEMENTATION_SCHEDULE_COMMENT = "implementation_schedule_comment";
export const IMPLEMENTATION_SCHEDULE_APPROVED = "implementation_schedule_approved";
export const IMPLEMENTATION_SCHEDULE_INPROGRESS = "implementation_schedule_in_progress";

export const MASTER_DEVELOPMENT_SCHEDULE_ACCESS = "master_development_schedule_access";
export const MASTER_DEVELOPMENT_SCHEDULE_CREATE = "master_development_schedule_create";
export const MASTER_DEVELOPMENT_SCHEDULE_VIEW = "master_development_schedule_view";
export const MASTER_DEVELOPMENT_SCHEDULE_EDIT = "master_development_schedule_edit";
export const MASTER_DEVELOPMENT_SCHEDULE_DELETE = "master_development_schedule_delete";
export const MASTER_DEVELOPMENT_SCHEDULE_COMMENT = "master_development_schedule_comment";
export const MASTER_DEVELOPMENT_SCHEDULE_APPROVED = "master_development_schedule_approved";
export const MASTER_DEVELOPMENT_SCHEDULE_INPROGRESS = "master_development_schedule_in_progress";

export const BASELINE_SCHEDULE_ACCESS = "baseline_schedule_access";
export const BASELINE_SCHEDULE_CREATE = "baseline_schedule_create";
export const BASELINE_SCHEDULE_VIEW = "baseline_schedule_view";
export const BASELINE_SCHEDULE_EDIT = "baseline_schedule_edit";
export const BASELINE_SCHEDULE_DELETE = "baseline_schedule_delete";
export const BASELINE_SCHEDULE_COMMENT = "baseline_schedule_comment";
export const BASELINE_SCHEDULE_APPROVED = "baseline_schedule_approved";
export const BASELINE_SCHEDULE_INPROGRESS = "baseline_schedule_in_progress";

export const RECOVERY_SCHEDULE_ACCESS = "recovery_schedule_access";
export const RECOVERY_SCHEDULE_CREATE = "recovery_schedule_create";
export const RECOVERY_SCHEDULE_VIEW = "recovery_schedule_view";
export const RECOVERY_SCHEDULE_EDIT = "recovery_schedule_edit";
export const RECOVERY_SCHEDULE_DELETE = "recovery_schedule_delete";
export const RECOVERY_SCHEDULE_COMMENT = "recovery_schedule_comment";
export const RECOVERY_SCHEDULE_APPROVED = "recovery_schedule_approved";
export const RECOVERY_SCHEDULE_INPROGRESS = "recovery_schedule_in_progress";

export const REBASELINE_SCHEDULE_ACCESS = "rebaseline_schedule_access";
export const REBASELINE_SCHEDULE_CREATE = "rebaseline_schedule_create";
export const REBASELINE_SCHEDULE_VIEW = "rebaseline_schedule_view";
export const REBASELINE_SCHEDULE_EDIT = "rebaseline_schedule_edit";
export const REBASELINE_SCHEDULE_DELETE = "rebaseline_schedule_delete";
export const REBASELINE_SCHEDULE_COMMENT = "rebaseline_schedule_comment";
export const REBASELINE_SCHEDULE_APPROVED = "rebaseline_schedule_approved";
export const REBASELINE_SCHEDULE_INPROGRESS = "rebaseline_schedule_in_progress";

export const UPDATE_SCHEDULE_ACCESS = "update_schedule_access";
export const UPDATE_SCHEDULE_CREATE = "update_schedule_create";
export const UPDATE_SCHEDULE_VIEW = "update_schedule_view";
export const UPDATE_SCHEDULE_EDIT = "update_schedule_edit";
export const UPDATE_SCHEDULE_DELETE = "update_schedule_delete";
export const UPDATE_SCHEDULE_COMMENT = "update_schedule_comment";
export const UPDATE_SCHEDULE_APPROVED = "update_schedule_approved";
export const UPDATE_SCHEDULE_INPROGRESS = "update_schedule_in_progress";
export const UPDATE_SCHEDULE_ACTUALUPDATE = "update_schedule_actualupdate";

export const CAPEX_ACCESS = "capex_access";
export const CAPEX_CREATE = "capex_create";
export const CAPEX_VIEW = "capex_view";
export const CAPEX_EDIT = "capex_edit";
export const CAPEX_DELETE = "capex_delete";
export const CAPEX_COMMENT = "capex_comment";
export const CAPEX_MENU_ACCESS = "capex_menu_access";
export const COMMITTED_COST_ACCESS = "committed_cost_access";

export const VIEW_SCHEDULE_ACCESS = "view_schedule_access";
export const ACTIVITY_WISE_ACCESS = "activity_wise_access";
export const RESOURCE_WISE_ACCESS = "resource _wise_access";

export const PHYSICAL_PROGRESS_ACCESS = "physical_progress_access";
export const PHYSICAL_PROGRESS_CREATE = "physical_progress_create";
export const PHYSICAL_PROGRESS_VIEW = "physical_progress_view";
export const PHYSICAL_PROGRESS_EDIT = "physical_progress_edit";
export const PHYSICAL_PROGRESS_DELETE = "physical_progress_delete";
export const PHYSICAL_PROGRESS_COMMENT = "physical_progress_comment";

export const MONTHLY_PLAN_ACCESS = "monthly_plan_access";
export const MONTHLY_PLAN_CREATE = "monthly_plan_create";
export const MONTHLY_PLAN_VIEW = "monthly_plan_view";
export const MONTHLY_PLAN_EDIT = "monthly_plan_edit";
export const MONTHLY_PLAN_DELETE = "monthly_plan_delete";
export const MONTHLY_PLAN_COMMENT = "monthly_plan_comment";

export const MILESTONE_ACCESS = "milestone_access";
export const MILESTONE_CREATE = "milestone_create";
export const MILESTONE_VIEW = "milestone_view";
export const MILESTONE_EDIT = "milestone_edit";
export const MILESTONE_DELETE = "milestone_delete";
export const MILESTONE_COMMENT = "milestone_comment";

export const MATERIAL_ACCESS = "material_access";
export const MATERIAL_CREATE = "material_create";
export const MATERIAL_VIEW = "material_view";
export const MATERIAL_EDIT = "material_edit";
export const MATERIAL_DELETE = "material_delete";
export const MATERIAL_COMMENT = "material_comment";

export const MANPOWER_ACCESS = "manpower_access";
export const MANPOWER_CREATE = "manpower_create";
export const MANPOWER_VIEW = "manpower_view";
export const MANPOWER_EDIT = "manpower_edit";
export const MANPOWER_DELETE = "manpower_delete";
export const MANPOWER_COMMENT = "manpower_comment";

export const MACHINERY_ACCESS = "machinery_access";
export const MACHINERY_CREATE = "machinery_create";
export const MACHINERY_VIEW = "machinery_view";
export const MACHINERY_EDIT = "machinery_edit";
export const MACHINERY_DELETE = "machinery_delete";
export const MACHINERY_COMMENT = "machinery_comment";

export const RISK_ACCESS = "risk_access";
export const RISK_CREATE = "risk_create";
export const RISK_VIEW = "risk_view";
export const RISK_EDIT = "risk_edit";
export const RISK_DELETE = "risk_delete";
export const RISK_COMMENT = "risk_comment";

export const COMPLIANCE_ACCESS = "compliance_access";
export const COMPLIANCE_CREATE = "compliance_create";
export const COMPLIANCE_VIEW = "compliance_view";
export const COMPLIANCE_EDIT = "compliance_edit";
export const COMPLIANCE_DELETE = "compliance_delete";
export const COMPLIANCE_COMMENT = "compliance_comment";

export const ENGINEERING_ACCESS = "engineering_access";
export const ENGINEERING_CREATE = "engineering_create";
export const ENGINEERING_VIEW = "engineering_view";
export const ENGINEERING_EDIT = "engineering_edit";
export const ENGINEERING_DELETE = "engineering_delete";
export const ENGINEERING_COMMENT = "engineering_comment";

export const STATUTORY_APPROVAL_ACCESS = "statutory_approval_access";
export const STATUTORY_APPROVAL_CREATE = "statutory_approval_create";
export const STATUTORY_APPROVAL_VIEW = "statutory_approval_view";
export const STATUTORY_APPROVAL_EDIT = "statutory_approval_edit";
export const STATUTORY_APPROVAL_DELETE = "statutory_approval_delete";
export const STATUTORY_APPROVAL_COMMENT = "statutory_approval_comment";

export const NCR_LOG_ACCESS = "ncr_log_access";
export const NCR_LOG_CREATE = "ncr_log_create";
export const NCR_LOG_VIEW = "ncr_log_view";
export const NCR_LOG_EDIT = "ncr_log_edit";
export const NCR_LOG_DELETE = "ncr_log_delete";
export const NCR_LOG_COMMENT = "ncr_log_comment";

export const PROCUREMENT_ACCESS = "procurement_access";
export const PROCUREMENT_CREATE = "procurement_create";
export const PROCUREMENT_VIEW = "procurement_view";
export const PROCUREMENT_EDIT = "procurement_edit";
export const PROCUREMENT_DELETE = "procurement_delete";
export const PROCUREMENT_COMMENT = "procurement_comment";

export const CLAIM_ACCESS = "claim_access";
export const CLAIM_CREATE = "claim_create";
export const CLAIM_VIEW = "claim_view";
export const CLAIM_EDIT = "claim_edit";
export const CLAIM_DELETE = "claim_delete";
export const CLAIM_COMMENT = "claim_comment";

export const CHANGE_ACCESS = "change_access";
export const CHANGE_CREATE = "change_create";
export const CHANGE_VIEW = "change_view";
export const CHANGE_EDIT = "change_edit";
export const CHANGE_DELETE = "change_delete";
export const CHANGE_COMMENT = "change_comment";

// config and settings
export const ACTION_TRACKER_DATA_ACCESS = "action_tracker_data_access";
export const COMPLIANCE_DATA_ACCESS = "compliance_data_access";
export const RISK_DATA_ACCESS = "risk_data_access";
export const WORKFLOW_DATA_ACCESS = "workflow_data_access";
export const DESIGN_ENGINEERING_DATA_ACCESS = "design_engineering_data_access";
export const EHS_FINDING_DATA_ACCESS = "ehs_finding_data_access";
export const HSE_DATA_ACCESS = "hse_data_access";
export const LEADS_DATA_ACCESS = "leads_data_access";
export const LEGAL_COMPLIANCE_DATA_ACCESS = "legal_compliance_data_access";
export const OPERATING_COST_DATA_ACCESS = "operating_cost_data_access";
export const PROCUREMENT_DATA_ACCESS = "procurement_data_access";
export const STATUTORY_APPROVAL_DATA_ACCESS = "statutory_approval_data_access";
export const WAREHOUSING_DATA_ACCESS = "warehousing_data_access";
export const RAIL_DATA_ACCESS = "rail_data_access";
export const COMMERCIAL_DATA_ACCESS = "commercial_data_access";
export const INSURANCE_DATA_ACCESS = "insurance_data_access";
export const PROJECT_SETTING = "project_setting_access";
export const WORKFLOW_ACCESS = "workflow_access";
export const MASTER_DATA_ACCESS = "master_data_access";

// dashboard permission 
export const COST_MANAGEMENT_ACCESS = "cost_management_access";
export const SCHEDULE_DASHBOARD_ACCESS = "schedule_dashboard_access";
export const ENGINEERING_DASHBOARD_ACCESS = "engineering_dashboard_access";
export const RISK_DASHBOARD_ACCESS = "risk_dashboard_access";
export const PROCUREMENT_DASHBOARD_ACCESS = "procurement_dashboard_access";
export const CONTRACT_MANAGEMENT_ACCESS = "contract_management_access";
export const HSE_DASHBOARD_ACCESS = "hse_dashboard_access";
export const LEASE_DASHBOARD_ACCESS = "lease_dashboard_access";


export const DMS_ACCESS = "dms_access";

export const INITIATE_WORKFLOW_ACCESS = "initiate_workflow_access";

// hse
export const HSE_ACCESS = "hse_access";
export const HSE_CREATE = "hse_create";

// incident
export const INCIDENT_ACCESS = "incident_access";
export const INCIDENT_CREATE = "incident_create";
export const INCIDENT_VIEW = "incident_view";
export const INCIDENT_EDIT = "incident_edit";

// ehs_finding_tracker
export const EHS_FINDING_TRACKER_ACCESS = "ehs_finding_tracker_access";
export const EHS_FINDING_TRACKER_CREATE = "ehs_finding_tracker_create";
export const EHS_FINDING_TRACKER_VIEW = "ehs_finding_tracker_view";
export const EHS_FINDING_TRACKER_EDIT = "ehs_finding_tracker_edit";
export const EHS_FINDING_TRACKER_DELETE = "ehs_finding_tracker_delete";

// legal_tracker
export const LEGAL_TRACKER_ACCESS = "legal_tracker_access";
export const LEGAL_TRACKER_CREATE = "legal_tracker_create";
export const LEGAL_TRACKER_VIEW = "legal_tracker_view";
export const LEGAL_TRACKER_EDIT = "legal_tracker_edit";

// invoice
export const INVOICE_TRACKER_ACCESS = "invoice_tracker_access";
export const INVOICE_TRACKER_CREATE = "invoice_tracker_create";
export const INVOICE_TRACKER_VIEW = "invoice_tracker_view";
export const INVOICE_TRACKER_EDIT = "invoice_tracker_edit";


// cost menu management
export const COST_TRACKER_ACCESS = "cost_tracker_access";
export const COST_UPDATE_ACCESS = "cost_update_access";


//IRR TRACKER
export const IRR_TRACKER_ACCESS = "irr_tracker_access";
export const IRR_TRACKER_CREATE = "irr_tracker_create";
export const IRR_TRACKER_VIEW = "irr_tracker_view";
export const IRR_TRACKER_EDIT = "irr_tracker_edit";

//REVENUE&LEASING TRACKER
export const REVENUE_TRACKER_ACCESS = "revenue_tracker_edit_tracker_access";
export const REVENUE_TRACKER_CREATE = "revenue_tracker_edit_tracker_create";
export const REVENUE_TRACKER_VIEW = "revenue_tracker_edit_tracker_view";
export const REVENUE_TRACKER_EDIT = "revenue_tracker_edit";

//CONSTRUCTION AND DEVELOPEMNT
export const CONSTRUCTION_DEVELOPMENT_TRACKER_ACCESS = "construction_development_tracker_access";
export const CONSTRUCTION_DEVELOPMENT_TRACKER_CREATE = "construction_development_tracker_create";
export const CONSTRUCTION_DEVELOPMENT_TRACKER_VIEW = "construction_development_tracker_view";
export const CONSTRUCTION_DEVELOPMENT_TRACKER_EDIT = "construction_development_tracker_edit";

//INSURANCE TRACKER
export const INSURANCE_TRACKER_ACCESS = "insurance_tracker_access";
export const INSURANCE_TRACKER_CREATE = "insurance_tracker_create";
export const INSURANCE_TRACKER_VIEW = "insurance_tracker_view";
export const INSURANCE_TRACKER_EDIT = "insurance_tracker_edit";

//CAM TRACKER
export const CAM_TRACKER_ACCESS = "cam_tracker_access";
export const CAM_TRACKER_CREATE = "cam_tracker_create";
export const CAM_TRACKER_VIEW = "cam_tracker_view";
export const CAM_TRACKER_EDIT = "cam_tracker_edit";


//OPERATING COST TRACKER
export const OPERATINGCOST_TRACKER_ACCESS = "operatingcost_tracker_access";
export const OPERATINGCOST_TRACKER_CREATE = "operatingcost_tracker_create";
export const OPERATINGCOST_TRACKER_VIEW = "operatingcost_tracker_view";
export const OPERATINGCOST_TRACKER_EDIT = "operatingcost_tracker_edit";

export const LEADS_TRACKER_ACCESS = "leads_tracker_access";
export const LEADS_TRACKER_CREATE = "leads_tracker_create";
export const LEADS_TRACKER_VIEW = "leads_tracker_view";
export const LEADS_TRACKER_EDIT = "leads_tracker_edit";
export const LEADS_TRACKER_DELETE = "leads_tracker_delete";

export const DEALS_TRACKER_ACCESS = "deals_tracker_access";
export const DEALS_TRACKER_CREATE = "deals_tracker_create";
export const DEALS_TRACKER_VIEW = "deals_tracker_view";
export const DEALS_TRACKER_EDIT = "deals_tracker_edit";
export const DEALS_TRACKER_DELETE = "deals_tracker_delete";

export const CUSTOMER_DEPENDENCIES_ACCESS = "customer_dependencies_access";
export const CUSTOMER_DEPENDENCIES_CREATE = "customer_dependencies_create";
export const CUSTOMER_DEPENDENCIES_VIEW = "customer_dependencies_view";
export const CUSTOMER_DEPENDENCIES_EDIT = "customer_dependencies_edit";
export const CUSTOMER_DEPENDENCIES_DELETE = "customer_dependencies_delete";

export const ERP_DATA_ACCESS = "erp_data_access";
export const ERP_DATA_CREATE = "erp_data_create";
export const ERP_DATA_VIEW = "erp_data_view";

export const FINANCIAL_BG_ACCESS = "financial_bg_access";
export const FINANCIAL_BG_CREATE = "financial_bg_create";
export const FINANCIAL_BG_VIEW = "financial_bg_view";
export const FINANCIAL_BG_EDIT = "financial_bg_edit";